import * as moment from 'moment';

import { Pipe, PipeTransform } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Pipe({
  name: 'toDate'
})
export class ToDatePipe implements PipeTransform {

  transform(value: string | NgbDateStruct, args?: any): Date {
    const result = (typeof value === 'string') ? moment(value) : moment({
      year: value.year,
      month: value.month - 1,
      day: value.day
    });
    return result.toDate();
  }

}
